






















































































































































































































































































































































































import Vue from 'vue';
import ServiceResponse from '../../../../../../src/plugins/servicelayer/responseTypes/serviceResponse';
import WidgetEventResourceViewModel from '../../services/v1/viewModel/resource/WidgetEventResourceViewModel';

export default Vue.extend({
  layout: 'layout-widget-no-design',
  data: () => ({
    eventId: undefined as number | undefined,
    model: new WidgetEventResourceViewModel(),
    isLoading: false,
    isAccordeonDetailVisible: [] as boolean[],
    responseError: undefined as any,
    isRegistrationExternalLink: false,
    registrationLink: undefined as string | undefined,
  }),
  computed: {
  },
  async mounted() {
    const pp = this.$routerUtils.getQueryParams();
    const eventid = this.$config.values['widget-eventid'] ?? this.$route.params.eventid ?? pp.eventid;
    if (this._.isSet(eventid)) {
      this.eventId = Number.parseInt(eventid, 10);
      if (!Number.isNaN(this.eventId)) {
        await this.populateData();
      } else {
        this.responseError = `${this.$t('widget.events.invalidEventNumber')}: ${pp.eventid}`;
      }
    } else {
      this.responseError = this.$t('widget.events.noEventNumberSpecified');
      this.$log.error('No eventId given');
    }
    this.registrationLink = this.$service.v1.api.core.widgetEvents.getEventRegisterUrl(this.model);
    this.isRegistrationExternalLink = !!this.$routerUtils.isUrl(this.registrationLink ?? '');
  },
  methods: {
    gotoRegister() {
      this.$routerUtils.pushRouteOrUrl(this.$service.v1.api.core.widgetEvents.getEventRegisterUrl(this.model));
    },
    async populateData() {
      this.isLoading = true;
      try {
        const response = await this.$service.v1.api.core.widgetEvents.getWidgetEventDetail(this.eventId!);
        this.model = response;
      } catch (e) {
        const errorResponse = e as ServiceResponse;
        if (errorResponse.status === 503) {
          // = errorResponse.data;
        }
        this.$log.error(e);
      }
      this.isLoading = false;
    },
    toggleDetail(index:number) {
      this.$set(this.isAccordeonDetailVisible, index, !this.isAccordeonDetailVisible[index]);
    },
  },
});
